$('document').ready(function() {
    $('#search_form').submit(function(e){
        if($("#search").val().length < 1 ){
            e.preventDefault();
        }
    });
});